
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { LineChart, Users, Zap, BarChart } from 'lucide-react';

const AdServiceCards: React.FC = () => {
  const serviceCards = [
    {
      id: "clarity",
      icon: <LineChart className="h-10 w-10 text-heading-accent" />,
      title: "Get Clarity and Strategy",
      description: "Not sure where to start? We'll help you spot the quick wins and build a plan that makes sense.",
      delay: "0ms"
    },
    {
      id: "agents",
      icon: <Users className="h-10 w-10 text-heading-accent" />,
      title: "Close Deals 24/7",
      description: "Turn AI into your highest-performing sales rep — agents that respond instantly, qualifying leads, and converting traffic into high-value customers day and night.",
      delay: "200ms"
    },
    {
      id: "workflow",
      icon: <Zap className="h-10 w-10 text-heading-accent" />,
      title: "Scale Faster With Less Work",
      description: "Build custom tools that eliminate busywork, streamline operations, and help your team deliver more in less time — without adding headcount.",
      delay: "400ms"
    },
    {
      id: "insights",
      icon: <BarChart className="h-10 w-10 text-heading-accent" />,
      title: "Better Insights",
      description: "Get dashboards and data tools that show you what's working and where to focus.",
      delay: "600ms"
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
      {serviceCards.map((card) => (
        <Card 
          key={card.id}
          className="p-8 border border-gray-200 dark:border-gray-700 hover:border-heading-accent/50 dark:hover:border-heading-accent/50 transition-all duration-500 shadow-sm hover:shadow backdrop-blur-sm animate-fade-in-up opacity-0 hover:translate-y-[-5px]"
          style={{
            animationDelay: card.delay,
            animationFillMode: "forwards"
          }}
        >
          <div className="mb-6 transform transition-transform duration-500 group-hover:scale-110">
            {card.icon}
          </div>
          <CardContent className="p-0">
            <h3 className="text-xl font-bold mb-3">{card.title}</h3>
            <p className="text-muted-foreground">{card.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AdServiceCards;
